<template>
    <nav class="flex" aria-label="Breadcrumb">
        <ol class="inline-flex items-center space-x-1 md:space-x-3">
            <li class="inline-flex items-center" v-for="(item, index) in breadcrumb" :key="index">
                <Link :href="item.link" class="inline-flex items-center text-sky-600 hover:text-sky-900">
                    <h2 class="capitalize font-semibold text-xl leading-tight">{{ setTitle(item.text) }}</h2>
                </Link>
                <div class="flex items-center" v-if="index != breadcrumb.length - 1">
                    <svg class="ml-3 w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clip-rule="evenodd"></path>
                    </svg>
                </div>
            </li>
        </ol>
    </nav>
</template>

<script>
    import {
        defineComponent
    } from 'vue'
    import {
        Link
    } from '@inertiajs/inertia-vue3';

    export default defineComponent({
        props: ['breadcrumb'],
        components: {
            Link
        },
        methods: {
            setTitle: function (title){
                return _.capitalize(_.startCase(title));
            }
        }
    })
</script>